import { BoxProps, ButtonProps, CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const ButtonOutsideArea = {
  display: 'none',
};

export const FlexContainer = (): CSSObject => ({
  px: ['2.5', null, null, '0'],
});

export const BoxWrapper: BoxProps = {
  pr: '0',
};

export const buttonLogInProps: ButtonProps = {
  variant: 'solid',
  height: '46px',
};

export const buttonSignUpProps: CustomButtonProps = {
  variant: 'primary',
  height: '46px',
};

export const buttonQuickAccessProps: CustomButtonProps = {
  variant: 'solid',
  height: '46px',
  p: '2.5',
  sx: {
    ':hover': {
      '.span-balance': {
        color: 'alpha.900',
      },
      '.span-bonus': {
        color: 'alpha.900',
      },
      '.chevron-icon': {
        color: 'alpha.900',
      },
    },
    '.btn-span': {
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      fontWeight: 'normal',
      mr: '1',
      gap: '0',
      mt: '0.5',
    },
    '.span-balance': {
      fontFamily: 'body',
      fontSize: 'md',
      lineHeight: '14px',
      fontWeight: 'black',
      color: 'beta.800',
    },
    '.span-bonus': {
      fontFamily: 'body',
      fontSize: '2xs',
      lineHeight: '10px',
      fontWeight: 'extrabold',
      color: 'beta.800',
      alignSelf: 'start',
    },

    'svg:not(.chevron-icon)': {
      pos: 'relative',
      top: '0.5',
      mr: '0.5',
    },
    '.chevron-icon': {
      pos: 'absolute',
      right: '1.5',
      top: '0',
      bottom: '0',
      margin: 'auto 0',
      color: 'beta.800',
    },

    '&&[aria-expanded="true"]': {
      borderBottomRadius: '0',
      bg: 'beta.200',
      boxShadow: 'none',
      textShadow: '0px 2px 2px rgba(0, 0, 0, 0.3)',
      zIndex: 'dropdown',
      '.chevron-icon': { transform: 'rotate(180deg)', color: 'alpha.200' },
      '.btn-span': {
        flexDir: 'column',
        zIndex: '9',
        textTransform: 'uppercase',
        fontWeight: 'normal',
        mr: '1',
        gap: '0',
        mt: '0.5',
      },
      '.span-balance': {
        fontFamily: 'body',
        fontSize: 'md',
        lineHeight: '14px',
        fontWeight: 'black',
        color: 'alpha.200',
      },
      '.span-bonus': {
        fontFamily: 'body',
        fontSize: '2xs',
        lineHeight: '10px',
        fontWeight: 'extrabold',
        color: 'alpha.200',
        alignSelf: 'start',
      },
      '&:after': {
        content: `''`,
        display: 'inline-block',
        h: '2',
        left: 0,
        right: 0,
        bottom: '-1.5',
        position: 'absolute',
      },
    },
  },
};

export const buttonBetsProps: ButtonProps = {
  variant: 'solid',
  height: '46px',
  padding: '0px 5px',
  pt: '12px',
  pb: '13px',
  fontWeight: 'black',
  fontFamily: 'body',
  sx: {
    '.btn-span': {
      lineHeight: '8px',
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      gap: '1.5',
    },
    '.span-bet': {
      fontSize: '2xs',
      color: 'beta.800',
    },
    '.span-bet-count': {
      fontSize: 'lg',
      color: 'beta.800',
    },
  },
};

export const buttonBetSlipProps: ButtonProps = {
  variant: 'solid',
  height: '46px',
  padding: '0px 5px',
  borderRadius: 'md',
  pt: '12px',
  pb: '13px',
  sx: {
    '.btn-span': {
      lineHeight: '8px',
      flexDir: 'column',
      zIndex: '9',
      textTransform: 'uppercase',
      gap: '1.5',
    },
  },
};

export const IconButtonMenu = (): CSSObject => ({
  bg: 'transparent',
  color: 'alpha.200',
  boxSize: '8',
  ml: '-1',
  mr: '5',
  mb: '3',

  '& svg': {
    boxSize: '10',
  },
});

export const FlexLeftGroup: CSSObject = {
  gap: '1.5',
  justifyContent: 'flex-start',
  alignItems: 'center',
};

export const buttonQuickAccess: ButtonProps = {
  variant: 'secondary',
};

export const ButtonGroupBets: CSSObject = {
  gap: '0.5',

  '> .chakra-button ~ .chakra-button': {
    marginInlineStart: 0,
  },
  '>*:first-of-type:not(:last-of-type)': {
    borderRightRadius: 'md',
  },
  '>*:not(:first-of-type):last-of-type': {
    borderLeftRadius: 'md',
  },
};

export const ButtonBetSlip: CSSObject = {
  ml: '0',
};

export const ButtonGroup: CSSObject = {
  gap: '1',
};

export const LinkLogo: CSSObject = {
  display: ['block', null, null, 'none'],
  ml: '-2',
};

export const TextButton: CSSObject = {
  fontWeight: 'black',
  fontFamily: 'body',
  fontSize: '2xs',
  color: 'beta.800',
};

export const TextButtonNumber: CSSObject = {
  fontWeight: 'black',
  fontFamily: 'body',
  fontSize: 'lg',
  color: 'beta.800',
};
